// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"500321ce","732":"5ac42c5c","977":"baa650f7"}[chunkId] + ".chunk.js";
};